<template>
	<div style="min-height: 281px; height: 281px">
		<b-row>
			<b-col cols="6">
				<b-row>
					<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
						<div class="sa-pianificazione-edit-container">
							<label for="">Ogni N giorni:</label>
							<b-form-input type="number" v-model="numeroGiorni"></b-form-input>
						</div>
					</b-col>
					<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
						<div class="sa-pianificazione-edit-container">
							<label for="">Orari</label>
							<div style="display: flex; flex-direction: row">
								<div style="flex: 1">
									<b-input-group class="mb-3">
										<date-picker format="HH:mm" value-type="timestamp" v-model="oraSelezionata" :disabled-time="disbilitaOrePrecedenti" placeholder="HH:mm" :default-value="new Date()" :minute-step="15" type="time" :disabled="orarioDisabled"></date-picker>
									</b-input-group>
								</div>
								<div>
									<b-button size="sm" variant="outline-success  pull-right" style="height: 29px" @click="onClickAggiungiOrario()" :disabled="btnDisabledAggiungiOrario">
										<i class="fas fa-plus"></i>
									</b-button>
								</div>
							</div>
							<label class="sa-label-data">Ora Programmata:</label>

							<div v-for="(ora, index) in hoursSelected" :key="index" style="display: flex; flex-direction: row" :class="getClass(index)">
								<div style="flex: 1; display: table">
									<span style="display: table-cell; vertical-align: middle; font-size: var(--label-font-size)">
										{{ ora }}
									</span>
								</div>
								<div>
									<b-button size="sm" variant="outline-danger outline-secondary pull-right " @click="onClickRemoveOrario(index)" :disabled="btnDisabledAggiungiOrario">
										<i class="far fa-trash-alt"></i>
									</b-button>
								</div>
							</div>
						</div>
					</b-col>
				</b-row>
			</b-col>
			<b-col cols="6">
				<b-row>
					<b-col cols="6" xs="6" sm="12" md="12" lg="12" xl="12">
						<div style="height: 300px; overflow-x: scroll">
							<label class="sa-label-data">Elenco delle prossime attività programmate:</label>
							<div v-for="(attivita, index) in elencoAttivitaProgrammate" :key="index" style="display: flex; flex-direction: row" :class="getClass(index)">
								<div style="flex: 1; display: table">
									<span style="display: table-cell; vertical-align: middle; font-size: var(--label-font-size)"> {{ index + 1 }} - {{ attivita }} </span>
								</div>
							</div>
						</div>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
export default {
	mixins: [UtilityMixin],
	components: { DatePicker },
	data() {
		return {
			jsonDataSchedulazione: null,
			pianificazione: { params: {} },
			days: [],
			daysSelected: [],
			hoursSelected: [],
			btnDisabledAggiungiOrario: true,
			numeroGiorni: null,
			orarioDisabled: false,
			oraSelezionata: null,
			orarioRiferimento: null,
			numeroElencoProgrammato: 10,
			elencoAttivitaProgrammate: [],
		};
	},
	created() {
		this.days = UtilityMixin.methods.getDaysOfWeekArray();
	},
	mounted() {
		this.$emit("afterMounted");
	},
	watch: {
		jsonDataSchedulazione: {
			handler() {
				this.aggiornaOrari();
			},
			deep: true,
		},
		daysSelected() {
			let me = this;
			me.pianificazione.giorni = me.daysSelected ? me.daysSelected.join(",") : "";
			this.$emit("updatePianificazioneGiorniAlternati", me.pianificazione);
			if (me.daysSelected) {
				me.orarioDisabled = false;
				me.btnDisabledAggiungiOrario = false;
			} else {
				me.hoursSelected = [];
				me.orarioDisabled = true;
				me.btnDisabledAggiungiOrario = true;
			}
		},
		hoursSelected() {
			let me = this;
			me.pianificazione.orari = me.hoursSelected ? me.hoursSelected.join(",") : "";
			this.$emit("updatePianificazioneGiorniAlternati", me.pianificazione);
		},
		numeroGiorni(value) {
			this.daysSelected = [];
			this.daysSelected.push(value);
			this.aggiornaOrari();
		},
		orarioRiferimento(value) {
			this.hoursSelected = [];
			console.log("in fucntion", value);

			this.hoursSelected.push(this.formatTime(value));
			this.$emit("updatePianificazioneGiorniAlternati", this.pianificazione);
			this.aggiornaOrari();
		},
	},
	methods: {
		init(jsonData) {
			let me = this;
			me.jsonDataSchedulazione = jsonData;
		},
		getClass(index) {
			if (index % 2 === 0) {
				return "sa-utility-alternate-even";
			} else {
				return "sa-utility-alternate-odd";
			}
		},
		aggiornaOrari() {
			let me = this;
			me.elencoAttivitaProgrammate = [];
			if (me.numeroGiorni && this.hoursSelected.length >= 1) {
				for (let x = 0; x < me.numeroElencoProgrammato; x++) {
					for (let h of this.hoursSelected) {
						let dataRiferimento = new Date(me.jsonDataSchedulazione.dataInizio + me.numeroGiorni * x * 24 * 60 * 60 * 1000);
						let [ora, min] = h.split(":");
						dataRiferimento.setHours(ora);
						dataRiferimento.setMinutes(min);

						me.elencoAttivitaProgrammate.push(me.formatDateTimeCustom(dataRiferimento, "dddd DD-MM-YYYY HH:mm"));
					}
				}
			}
		},
		disbilitaOrePrecedenti(date) {
			let me = this;
			let today = new Date();
			let dataRiferimento = new Date(me.pianificazione.dataInizio);
			if (dataRiferimento.getFullYear() === today.getFullYear() && dataRiferimento.getMonth() === today.getMonth() && dataRiferimento.getDate() === today.getDate()) {
				return date.getHours() < new Date().getHours();
			} else {
				return false;
			}
		},
		setPianificazione(jsonDataSchedulazione, pianificazione) {
			let me = this;
			me.jsonDataSchedulazione = jsonDataSchedulazione;
			console.log(pianificazione);
			me.pianificazione.giorni = pianificazione.giorni;
			me.pianificazione.orari = pianificazione.orari;
			me.pianificazione.tipo = pianificazione.tipo;
			try {
				me.pianificazione.params = JSON.parse(pianificazione.params);
				if (typeof me.pianificazione.params !== "object") {
					me.pianificazione.params = {};
				}
			} catch {
				me.pianificazione.params = {};
			}
			console.log(me.pianificazione.params);
			console.log(me.pianificazione);
			me.daysSelected = jsonDataSchedulazione.giorni ? jsonDataSchedulazione.giorni.split(",") : [];
			me.hoursSelected = jsonDataSchedulazione.orari ? jsonDataSchedulazione.orari.split(",") : [];
			me.numeroGiorni = me.pianificazione.giorni;
			me.orarioRiferimento = me.parseFormatDateTime(me.pianificazione.orari, "HH:mm").getTime();
			// if (me.hoursSelected <= 1) {
			//
			// } else {
			//   for (let hou of me.hoursSelected) {
			//     me.orarioRiferimento = me.parseFormatDateTime(hou, "HH:mm").getTime();
			//   }
			// }
		},
		onInputDaysAll(value) {
			let me = this;
			me.daysSelected = [];
			if (value) {
				this.days.forEach((element) => {
					me.daysSelected.push(element.code);
				});
			}
		},
		onClickRemoveOrario(index) {
			let me = this;
			me.hoursSelected.splice(index, 1);
		},
		onClickAggiungiOrario() {
			let me = this;
			console.log("schedulazione", me.jsonDataSchedulazione);

			if (this.oraSelezionata) {
				me.hoursSelected.push(me.formatTime(this.oraSelezionata));
				me.hoursSelected = [...new Set(me.hoursSelected)];
				me.hoursSelected.sort();
			}
			me.aggiornaOrari();
		},
	},
};
</script>

<style></style>
